"use client";

import { useState } from "react";
import { Button, Fade, Stagger, StaggerItem, Card, CardContent } from "@aio/platform-ui";

export default function AnimationsPage() {
  const [count, setCount] = useState(0);
  const items = Array.from({ length: 8 }, (_, i) => `Item ${i + 1}`);

  return (
    <div className="space-y-10">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Animations</h1>
        <p className="mt-1 text-fg-muted">Subtle, opinionated motion using motion library.</p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Fade (re-mount on click)</h2>
        <Button onClick={() => setCount((c) => c + 1)}>Re-mount</Button>
        <div className="mt-4">
          <Fade key={count}>
            <Card>
              <CardContent className="p-6">Fade #{count}</CardContent>
            </Card>
          </Fade>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Stagger</h2>
        <Stagger className="grid grid-cols-4 gap-2">
          {items.map((it) => (
            <StaggerItem key={it}>
              <Card>
                <CardContent className="p-4 text-sm">{it}</CardContent>
              </Card>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
